import { createApp } from 'vue';
import './index.css';
import './logger.js';
import App from './App.vue';

createApp(App).mount('#app');
